import script from "./Rules.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rules.vue?vue&type=script&setup=true&lang=ts"

import "./Rules.vue?vue&type=style&index=0&id=12a9fe38&scoped=true&lang=css"
import "./Rules.vue?vue&type=style&index=1&id=12a9fe38&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a9fe38"]])

export default __exports__